import React from 'react'

import ImageLogo from "../../../image/logo_main.png"
import moment from 'moment'
import { convertStatusInvoiceClaim, convertStatusPaid, numberFormat } from '../../../helpers'
import { Table, Badge, Row, Col, Card } from "react-bootstrap"
import { IMAGE_ENDPOINT, S3_URL } from '../../../constants'

function InvoiceDetail({ preparData }) {
    const clidDatas = JSON.parse(preparData?.datas?.paymentData)
    const fileName = preparData?.datas?.paySlip ? preparData?.datas?.paySlip.split("/").pop() : null;
    const isPhapay = fileName?.startsWith("phapay");
    const shopId = localStorage.getItem("SHOP")  
    const currency = preparData?.datas?.currency
    
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            <h3 style={{ fontWeight: 'bold' }}>ບິນແຈ້ງເຄມເງິນ</h3>
            <br />

            <div className='d-flex justify-content-between align-items-start w-100'>
                <img src={ImageLogo} style={{ maxWidth: 70, maxHeight: 70, borderRadius: '40em', border: '1px solid #ddd' }} />
                <div className='d-flex justify-content-end flex-column  align-items-end'>
                    <p>ເລກບິນ:  {preparData?.datas?.code}</p>
                    <p style={{ marginTop: '-.4em' }}>ວັນທີ: {moment(preparData?.datas?.createdAt).format("DD/MM/YYYY HH:mm")}</p>
                </div>
            </div>
            <div className='d-flex flex-column justify-content-start align-items-start w-100'>
                <p>ຊື່ຮ້ານ: {preparData?.datas?.shopName ?? "-"}</p>
                <p style={{ marginTop: '-.4em' }}>ສະຖານະບິນ: {convertStatusInvoiceClaim(preparData?.datas?.status)}</p>
            </div>
            <div className='w-100'>
                <Table>
                    <thead style={{ borderBottom: "none" }}>
                        <tr>
                            <th>
                                ລຳດັບ
                            </th>
                            <th>ລະຫັດອໍເດີ້</th>
                            <th>ຈຳນວນເງິນ</th>
                            {/* <th>ຄ່າບໍລິການລະບົບ</th> */}
                            <th style={{ textAlign: 'right' }}>ວັນທີ,ເດືອນ,ປີ</th>
                            {/* <th>ໝາຍເຫດ</th> */}
                        </tr>
                    </thead>
                    <tbody>

                        {clidDatas.map((item, index) => (
                            <tr
                                key={index}
                            >
                                <td>
                                    {index + 1}
                                </td>
                                <td>{item?.remark}</td>
                                <td>{numberFormat(item?.amount) ?? 0}</td>
                                {/* <td>2,000</td> */}
                                <td style={{ textAlign: 'right' }}>
                                    {moment(item?.createdAt).format("DD/MM/YYYY HH:mm")}
                                </td>
                                {/* <td>-</td> */}
                            </tr>
                        ))}
                    </tbody>

                </Table>
            </div>

            <Row className='w-100'>
                <Col></Col>
                <Col style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                    <div className='w-100 text-align-left' style={{ minWidth: 320, ontWeight: 'bold' }}>
                        <h5>ຈຳນວນ:</h5>
                        <h5 style={{ marginTop: '-.4em' }}>ຍອດເງິນທີ່ຮ້ານໄດ້:</h5>
                        {/* <h5 style={{ marginTop: '-.4em' }}>ລວມຄ່າບໍລິການລະບົບ:</h5> */}
                    </div>
                    <div className='w-100 text-align-right' style={{ fontWeight: 'bold', minWidth: 140, display: 'flex', flexDirection: 'column', justifyContent: 'end', alignItems: 'end' }}>
                        <h5>{preparData?.datas?.amount ?? 0} ລາຍການ</h5>
                        <h5 style={{ marginTop: '-.4em' }}>{numberFormat(preparData?.datas?.totalPrice) ?? 0} {currency === "USD" ? "USD" : "ກີບ"}</h5>
                        {/* <h5 style={{ marginTop: '-.4em' }}>{numberFormat(clidDatas?.length * 2000)} ກີບ</h5> */}
                    </div>
                </Col>
            </Row>

            <hr />


            {preparData?.datas?.paySlip &&
                <div style={{ width: '100%', }}>
                    <p style={{ fontWeight: 'bold' }}>
                        {isPhapay ? "ຂໍ້ມູນການຊຳລະເງິນ" :  "ບໍ່ມີສະລິບການໂອນ" }
                    </p>
                    {
                        isPhapay && (
                            <Card style={{ boxShadow: 'none', display: 'flex', justifyContent: 'center' }}>
                                <Card.Body style={{ display: 'flex', justifyContent: 'center' }}>
                                    {fileName.startsWith("phapay") && (
                                        <img
                                        src={`${IMAGE_ENDPOINT}file/get-files/${fileName}`}
                                        alt="Payment slip"
                                        style={{ width: "200px", borderRadius: "8px" }}
                                        />
                                    )}

                                </Card.Body>
                            </Card>
                        )
                    }
                </div>
            }
            {preparData?.datas?.note &&
                <div style={{ width: '100%', marginTop: 5 }}>
                    <p style={{ fontWeight: 'bold' }}>ໝາຍເຫດ:</p>
                    <Card style={{ boxShadow: 'none', padding: 5 }}>
                        <Card.Text>
                            {preparData?.datas?.note}
                        </Card.Text>
                    </Card>
                </div>}
            <hr />

            <div style={{ width: '100%', display: 'flex', justifyContent: 'start', alignItems: 'start' }}>
                <small>ບໍລິສັດ: Lailaolab ICT Solutions CO.,LTD <br />
                    ເບີໂທຕິດຕໍ່ 020 98 962 978, ອີເມວ info@bbbb.com.la</small> <br />
            </div>



        </div>
    )
}

export default InvoiceDetail
